import { Box, styledComponent, Typography } from '@hermes/web-components'

export const BodyContainer = styledComponent(Box, {
  shouldForwardProp: (prop) => prop !== 'disablePadding'
})<{ disablePadding?: boolean }>(({ theme, disablePadding = false }) => ({
  maxWidth: '480px',
  width: '100%',
  margin: '0 auto',
  paddingTop: '40px',
  paddingBottom: '100px', // allow room for the stick footer bar
  [theme.breakpoints.down('sm')]: {
    padding: disablePadding ? '0' : '0 16px'
  }
}))

export const BundleBanner = styledComponent(Box)(({ theme }) => ({
  backgroundColor: theme.palette.tertiary[200],
  width: '100%',
  marginTop: '40px',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'row',
  height: '110px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '16px'
  },
  [theme.breakpoints.down('md')]: {
    height: '126px'
  },
  svg: {
    height: '100%',
    minWidth: 'initial',
    flexShrink: 0
  },
  '.MuiBox-root': {
    alignSelf: 'center',
    padding: '16px 8px 16px 16px',
    '.MuiTypography-root': {
      '&:first-of-type': {
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: 700
      }
    }
  }
}))

export const AlsoSellingTitle = styledComponent(Typography)(({ theme }) => ({
  color: theme.palette.neutral[600],
  marginTop: '57px',
  fontFamily: 'PT Serif',
  fontWeight: 700,
  fontSize: '28px',
  lineHeight: '36px',
  marginBottom: '49px',
  [theme.breakpoints.down('sm')]: {
    marginTop: '33px',
    marginBottom: '32px'
  }
}))

export const CollectionTitle = styledComponent(Typography)(({ theme }) => ({
  color: theme.palette.neutral[600],
  fontFamily: 'PT Serif',
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '32px',
  marginTop: '57px',
  marginBottom: '32px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
    lineHeight: '24px',
    marginTop: '40px',
    marginBottom: '16px'
  }
}))

export const WithoutCarousel = styledComponent(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: '16px',
  '.book-card': {
    marginBottom: '40px'
  },
  '.book-card-image': {
    span: {
      position: 'initial !important'
    },
    width: '100%',
    paddingBottom: '164.71%'
  },
  [theme.breakpoints.down('md')]: {
    '.book-card': {
      width: '100%',
      maxWidth: 'initial'
    }
  },
  [theme.breakpoints.down('xs')]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))'
  }
}))

export const BookCardAdditionalInfo = styledComponent(Box)(({ theme }) => ({
  marginTop: '4px',
  '.MuiTypography-root': {
    lineHeight: '16px',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    color: theme.palette.neutral.main,
    fill: theme.palette.neutral.main,
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}))

export const FooterContainer = styledComponent(Box)(({ theme }) => ({
  position: 'fixed',
  width: '100%',
  height: '84px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.neutral[100],
  borderTop: `1px solid ${theme.palette.neutral[300]}`,
  bottom: 0,
  zIndex: 999
}))

export const CollectionContainer = styledComponent(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    '.swiper': {
      margin: '0 -16px',
      padding: '0 16px'
    },
    '.carousel-nav-button': {
      display: 'none'
    }
  }
}))

export const BookInCard = styledComponent(Typography)(() => ({
  WebkitLineClamp: '1',
  wordBreak: 'break-all',
  WebkitBoxOrient: 'vertical',
  display: '-webkit-box',
  overflow: 'hidden',
  marginLeft: '10px'
}))
